<template>
    <div class="bg-lightest WidgetCostumizeContainer">

        <div v-if="!selectedWidget || selectedWidget == null">
            Loading Widget
        </div>

        <div v-else>

            <div class="container">
                <div class="row">

                    <div class="col-sm-12">
                        <div class="darker fs-largest my-3">
                            Costumize your widget according to your needs
                        </div>
                    </div>

                </div>

                <div class="row">
                    <!-- Column -->
                    <div class="col-md-12 col-lg-6">

                        <div class="w-100">
                            <div class="iframeContainerParent d-flex justify-content-center my-3">
                                <div class="iframeContainer">
                                    <div class="dark iframeLabel">Iframe Container</div>
                                    <iframe
                                        class="iframeExample"
                                        :src="widgetLink"
                                        height="600"
                                        :style="widgetStyle"
                                        allow="payment">
                                    </iframe>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Column -->
                    <div class="col-md-12 col-lg-6">
                        <div class="row">

                            <!-- Rules -->
                            <div class="col-sm-12 mb-3">
                                <div class="darker fs-largest my-3">
                                    Widget Rules
                                </div>
                                <ul>
                                    <li>
                                        The widget can not have any other element covering it
                                    </li>
                                    <li>
                                        The minium width of the widget is 300px
                                    </li>
                                    <li>
                                        The minium height of the widget is 450px
                                    </li>
                                </ul>
                            </div> <!-- rules end -->


                            <!-- Controls -->
                            <div class="col-sm-12">
                                <div class="controlsHolder border-light radius-normal py-1">

                                    <div class="d-flex align-items-center mb-1">
                                        <div class="flex-grow-1 d-flex justify-content-between pr-3">
                                            <div>Width:</div>
                                            <div class="d-flex"><checkbox class="mr-1" value="true" v-model="widgetSettings.fullWidth"></checkbox>Use 100% *</div>
                                        </div>
                                        <div>
                                            <i class="fas fa-minus-circle fs-larger dark mx-0" @click="decreaseValue('width', limits.widthMin, widgetSettings.fullWidth)"></i>
                                            <input
                                                type="number"
                                                class="text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1"
                                                style="width: 2rem;"
                                                value="0"
                                                v-model="widgetSettings.width"
                                                :disabled="widgetSettings.fullWidth"
                                                @input.lazy="valueManuallyChanged($event, 'width', limits.widthMin, limits.widthMax)">
                                            </input>
                                            <i class="fas fa-plus-circle fs-larger dark mx-0" @click="increaseValue('width', limits.widthMax, widgetSettings.fullWidth)"></i>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center mb-1">
                                        <div class="flex-grow-1 d-flex justify-content-between pr-3">
                                            <div>Height:</div>
                                            <div class="d-flex"><checkbox class="mr-1" value="true" v-model="widgetSettings.fullHeight"></checkbox>Use 100% *</div>
                                        </div>
                                        <div>
                                            <i class="fas fa-minus-circle fs-larger dark mx-0" @click="decreaseValue('height', limits.heightMin, widgetSettings.fullHeight)"></i>
                                            <input
                                                type="number"
                                                class="text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1"
                                                style="width: 2rem;"
                                                value="0"
                                                v-model="widgetSettings.height"
                                                :disabled="widgetSettings.fullHeight"
                                                @input.lazy="valueManuallyChanged($event, 'height', limits.heighthMin, limits.heightMax)">
                                            </input>
                                            <i class="fas fa-plus-circle fs-larger dark mx-0" @click="increaseValue('height', limits.heightMax, widgetSettings.fullHeight)"></i>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center mb-1">
                                        <div class="flex-grow-1">Top Margin:</div>
                                        <div>
                                            <i class="fas fa-minus-circle fs-larger dark mx-0" @click="decreaseValue('topMargin', limits.marginMin, false)"></i>
                                            <input type="number" class="text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1" style="width: 2rem;" value="0" v-model="widgetSettings.topMargin" @input.lazy="valueManuallyChanged($event, 'topMargin', limits.marginMax, limits.marginMin)"></input>
                                            <i class="fas fa-plus-circle fs-larger dark mx-0" @click="increaseValue('topMargin', limits.marginMax, false)"></i>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center mb-1">
                                        <div class="flex-grow-1">Bottom Margin:</div>
                                        <div>
                                            <i class="fas fa-minus-circle fs-larger dark mx-0" @click="decreaseValue('bottomMargin', limits.marginMin, false)"></i>
                                            <input type="number" class="text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1" style="width: 2rem;" value="0" v-model="widgetSettings.bottomMargin" @input.lazy="valueManuallyChanged($event, 'bottomMargin', limits.marginMax, limits.marginMin)"></input>
                                            <i class="fas fa-plus-circle fs-larger dark mx-0" @click="increaseValue('bottomMargin', limits.marginMax, false)"></i>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center mb-1">
                                        <div class="flex-grow-1">Bottom Left:</div>
                                        <div>
                                            <i class="fas fa-minus-circle fs-larger dark mx-0" @click="decreaseValue('leftMargin', limits.marginMin, false)"></i>
                                            <input type="number" class="text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1" style="width: 2rem;" value="0" v-model="widgetSettings.leftMargin" @input.lazy="valueManuallyChanged($event, 'leftMargin', limits.marginMax, limits.marginMin)"></input>
                                            <i class="fas fa-plus-circle fs-larger dark mx-0" @click="increaseValue('leftMargin', limits.marginMax, false)"></i>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center mb-1">
                                        <div class="flex-grow-1">Bottom Right:</div>
                                        <div>
                                            <i class="fas fa-minus-circle fs-larger dark mx-0" @click="decreaseValue('rightMargin', limits.marginMin, false)"></i>
                                            <input type="number" class="text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1" style="width: 2rem;" value="0" v-model="widgetSettings.rightMargin" @input.lazy="valueManuallyChanged($event, 'rightMargin', limits.marginMax, limits.marginMin)"></input>
                                            <i class="fas fa-plus-circle fs-larger dark mx-0" @click="increaseValue('rightMargin', limits.marginMax, false)"></i>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-end mb-1">
                                        <button class="btn tertiary small" @click="loadDefaults()">Load defaults</button>
                                    </div>

                                </div> <!-- controls end -->

                                <div class="dark fs-small">
                                    * Using 100% will make the widget fit the limits of the container.
                                </div>

                            </div>

                            <!-- Widget Code -->
                            <div class="col-sm-12">
                                <div class="darker fs-largest my-3">
                                    Widget code
                                </div>

                                <div class="bg-lighter darkest border-dark radius-normal p-2 darkest">
                                    {{iframeCode}}
                                </div>
                            </div>

                            <!-- Notes -->
                            <div class="col-sm-12">
                                <div class="darker fs-largest my-3">
                                    Notes
                                </div>

                                <div class="notesLines">
                                    <div>- You can send this link to the persone responsible for your website.</div>
                                    <div>- After changing your widget settings you must copy the widget code and paste it on you website code.</div>
                                    <div>- The settings used on this tool are not saved, everytime this tool is opened it starts with the default values.</div>
                                </div>
                            </div>

                        </div> <!-- row end -->

                    </div>

                </div>


            </div>

        </div>

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    created:function() {
        // get Widget
        this.selectedWidget = this.$route.params.widgetGuid
    },
    data: function() {
        return {
            selectedWidget: null,
            limits: {
                widthMax: 400,
                widthMin: 300,
                heightMax: 999999,
                heightMin: 450,
                marginMax: 80,
                marginMin: 0,
            },
            widgetSettingsDefaults:{
                width: 400,
                height: 450,
                fullWidth: false,
                fullHeight: false,
                topMargin: 0,
                bottomMargin: 0,
                leftMargin: 0,
                rightMargin: 0,
            },
            widgetSettings:{
                width: 400,
                height: 450,
                fullWidth: false,
                fullHeight: false,
                topMargin: 0,
                bottomMargin: 0,
                leftMargin: 0,
                rightMargin: 0,
            }
        }
    },
    computed: {
        ...mapGetters([
            'getSelectedWidget'
        ]),
        widgetLink: function () {
            if(this.selectedWidget){
                return process.env.WIDGET_URL+'/?guid='+this.selectedWidget
            } else {
                return null
            }
        },
        widgetStyle: function () {

            let width = this.widgetSettings.fullWidth? '100%' : this.widgetSettings.width + 'px'
            let height = this.widgetSettings.fullHeight? '100%' : this.widgetSettings.height + 'px'
            return {
                // 'position': 'relative',
                // 'display': 'block',
                'margin': 'auto',
                'border': 'none',
                // 'width': '100%',
                'margin-left': `${this.widgetSettings.leftMargin}px`,
                'margin-right': `${this.widgetSettings.rightMargin}px`,
                'width': `${width}`,
                'max-width': `${width}`,
                'height': `calc(${height} - ${(this.widgetSettings.topMargin + this.widgetSettings.bottomMargin)}px)`,
                'max-height': `calc(${height} - ${(this.widgetSettings.topMargin + this.widgetSettings.bottomMargin)}px)`,
                'margin-top': `${this.widgetSettings.topMargin}px`,
                'margin-bottom': `${this.widgetSettings.bottomMargin}px`,
                'min-height': '450px',
                // 'max-height': '600px',
            }
        },
        iframeCode: function () {
            let styleString = ''
            for (var key in this.widgetStyle) {
                if (this.widgetStyle.hasOwnProperty(key)) {
                    styleString += `${key}: ${this.widgetStyle[key]}; `
                }
            }
            return `<iframe src="${this.widgetLink}" height="600" style="${styleString}" allow="payment"></iframe>`
        }
    },
    methods: {
        ...mapActions([
            'getSepcificWidget'
        ]),
        loadDefaults: function () {
            this.widgetSettings = this.widgetSettingsDefaults
        },
        increaseValue: function (value, limit, disabled) {
            console.log('increaseValue', value);
            if(disabled){
                return false
            }
            let incrementAmount = 10
            if(this.widgetSettings[value] + incrementAmount <= limit){
                this.widgetSettings[value] += incrementAmount
            } else {
                console.log('Limit reached');
            }
        },
        decreaseValue: function (value, limit, disabled) {
            console.log('decreaseValue', value);
            if(disabled){
                return false
            }
            let incrementAmount = 10
            if(this.widgetSettings[value] - incrementAmount >= limit){
                this.widgetSettings[value] -= incrementAmount
            } else {
                console.log('Limit reached');
            }
        },
        valueManuallyChanged: function ($event, valueLabel, minValue, maxValue) {
            let inputValue = Number($event.data)
            if(inputValue > maxValue){
                console.log('higher');
                this.widgetSettings[valueLabel] = maxValue
                // $event.data = maxValue
            } else if (inputValue < minValue) {
                console.log('lower');
                this.widgetSettings[valueLabel] = minValue
                // $event.data = minValue
            } else {
                console.log('good');
                this.widgetSettings[valueLabel] = inputValue
                // $event.data = inputValue
            }
            console.log('valueManuallyChanged', inputValue, valueLabel, minValue, maxValue);
        }
    },
    components: {
    }
}
</script>

<style lang="scss" scoped>
@import"~@/assets/scss/_variables.scss";
.WidgetCostumizeContainer{
    min-height: 100vh;
    padding-bottom: 50px;
}
.iframeContainer{
    position: relative;
    display: inline-block;
    border: 2px dashed $dark;

    .iframeLabel{
        position: absolute;
        top: -1.6em;
    }

    .iframeExample{
        position: relative;
        display: block;
    }
}

.controlsHolder {
    background-color: $lighter;
    & > div{
        padding: 3px 10px;
    }
    & > div:nth-child(odd){
        background-color: $lighter;
    }
    & > div:nth-child(even){
        background-color: $lightest;
    }
}

.notesLines{
    div{
        margin-bottom: 2px;
    }
}
</style>



// WEBPACK FOOTER //
// WidgetCostumize.vue?0aa5d21f